module.exports = __webpack_public_path__ + "static/ariadne-logo-48854854428a1d7a933520cde2b53363.png";